export const date = {
  methods: {
    formatDateTimezone(givenDate) {
      let date = new Date(givenDate).toLocaleString('en-GB', { timeZone: 'Europe/London' });

      return date.replace(",", "").substring(0, 16);
    },
    formatDate(givenDate, readable, withTime) {
      let date = givenDate ? new Date(givenDate) : new Date();

      let dd = date.getDate();

      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }

      let hour = date.getHours();
      let minutes = date.getMinutes();

      if (hour < 10) {
        hour = "0" + hour;
      }

      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      let time = "";
      if (withTime) {
        time = " " + hour + ":" + minutes;
      }

      if (readable) {
        return dd + '/' + mm + '/' + yyyy + time;
      }
      return yyyy + "-" + mm + "-" + dd;
    },
    useDate(prop) {
      if (!prop) {
        return null;
      }

      return this.formatDate(prop);
    }
  },
  computed: {
    todayDate() {
      return this.formatDate();
    },
    tomorrowDate() {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return this.formatDate(tomorrow);
    },
    dateRanges() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      return {
        Today: [today, today],
        Tomorrow: [tomorrow, tomorrow]
      };
    },
    dateRangesYesterday() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      return {
        Yesterday: [yesterday, yesterday],
        Today: [today, today]
      };
    }
  }
};
